<template>
  <!-- Vi labels-->
  <span>
    <v-card text v-if="showCard  && count">
      <v-toolbar v-if="!hideTitle">
        <v-toolbar-title>
          <logo name="fid" small></logo>
          <span class="caption ml-1">{{labelCaption}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <tool-chip-count
          :count="count"
          class="mr-1"
          :tooltip="`${count} ${labelCaption} labels`"
          left
        ></tool-chip-count>

        <hide-detail
          :prop-name="labelType"
          :tooltip="labelCaption"
          left
          :hide="!showCardDetail"
          @hide="hide"
        ></hide-detail>
      </v-toolbar>

      <v-card-text v-if="showCardDetail" class="text-xs-center">

        <span v-if="filterCount">
          <content-detail
            :items="reasons"
            :compressed="false"
            :row-type="rowType"
            :item-type="rowType"
            score
            :card-title="contentHeading"
            merge-button
            @merge="merge"
            :player-instance="disambigTypes"
            :merge-into="thisFilm"
          ></content-detail>

        </span>
        <span v-else-if="!isLoading">
          <span v-if="!referenceScore">The label data is not distinct enough to compare with other films
          </span><span v-else>The labels are a lower confidence than the confidence ({{confidence}}) selected. Try moving the confidence slider left to see them</span>
        </span>
        <span v-else>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            color="accent"
            :active="isLoading"
            height="2"
          ></v-progress-linear>
        </span>

      </v-card-text>
    </v-card>

  </span>
</template>
<script>
import Logo from "@/components/Logo";
import Contentdetail from "@/components/Contentdetail";

import { mergeFilm } from "@/gql";
import { Disambig } from "@/gql";
import { getIconColor, getIcon, settings } from "@/js/store";
import { mapState, mapMutations, mapGetters } from "vuex";
import { vxMaps } from "@/js/vxstore";
import Toolchipcount from "@/components/Toolchipcount";
import Hidedetail from "@/components/Hidedetail";
import { mutate } from '@/js/apollo'
import { showToaster  } from '@/js/apollo'

export default {
  components: {
    logo: Logo,
    "tool-chip-count": Toolchipcount,
    "hide-detail": Hidedetail,
    "content-detail": Contentdetail
  },
  props: {
    hideTitle: Boolean,
    editable: Boolean,
    film: {
      type: Object,
      required: true
    },
    fmid: {
      type: String
    },
    // identifies the kind of label to be displayed
    labelType: {
      type: String,
      required: true
    },
    labelCaption: {
      type: String,
      required: true
    },
    // this is a summary of counts by type to avoid the query if its not openedup
    count: Number,
    contentHeading: String,
    disambigTypes: String
  },

  methods: {
    merge (pack) {

      const {match: sourceName, matchID: sourceID} = pack
      if (sourceID === this.filmID) {
        showToaster({
          header: 'error',
          type: 'error',
          message: 'something went wrong - cant merge a film with itself'
        })
      } else {
        this.$dialog.confirm({
          title:`Merging ${sourceName}:${sourceID} into ${this.filmName}:${this.filmID}`,
          body:`Once merged, this will also remove film ${sourceName}:${sourceID} - are you sure ?`
          }, {
            okText: 'Merge',
            loader: true,
            cancelText: 'Cancel',
            animation: 'fade'
          })
          .then(dialog=> {
            const  variables= {
              id: sourceID,
              targetID: this.filmID
            }

            return mutate({
              mutation: mergeFilm,
              variables
            })
            .then(r=> {
              showToaster({
                header: 'Merge completed',
                type: 'success',
                message: 'The films have been successfully merged'
              })
              dialog.close()
              this.$emit("refreshfilm", this.film)
              return r;
            })

          })
          .catch(err => {
            if(err) {
              showToaster({
                header: 'Something went wrong',
                type: 'error',
                message: err,
                error: err
              })
            } else {
              console.log(err, 'Clicked on cancel');
            }

          })
      }

    },
    // the ref score is caclulated assuming that the same film  score is 1
    refScore(match) {
      return this.referenceScore ?  match.score/this.referenceScore : 0
    },
    getIcon(name) {
      return getIcon(name);
    },
    getIconColor(name) {
      return getIconColor(name);
    },
    hide(pack) {
      this.setVActiveSub(pack.hide ? null : pack.propName);
    },
    isThisFilm(film) {
      const s = (this.thisFilm && this.thisFilm.filmID) === (film && film.filmID)
      return s
    },
    ...mapMutations(vxMaps.mutations)
  },
  data: () => ({
    Disambig: null,
    rowType: "film"
  }),

  computed: {
    filmID () {
      return this.film && this.film.id
    },
    filmName () {
      return this.film && this.film.filmName
    },
    daResult () {
      // this will prevent the results from the previous match being shown
      const d = this.Disambig && this.Disambig.FilmDisambigResult;
      return this.filmMasterID && d && this.filmMasterID === d.filmMasterID && d
    },
    best () {
      return this.daResult && this.daResult.Best
    },
    hits () {
      return this.daResult && this.daResult.FilmDisambigHits
    },
    totalItems () {
      return this.daResult && this.daResult.totalItems
    },
    maxScore () {
      return this.daResult && this.daResult.maxScore
    },
    isLoading () {
      // can be used to detect if data is being fetched
      return this.$apollo.loading
    },
    showCard() {
      return this.showLabels && (this.vActiveSub === this.labelType || !this.vActiveSub);
    },
    alwaysShow () {
      return this.bigActiveSection === "similarsection" 
    },
    showCardDetail() {
      return (
        this.alwaysShow || (
        this.showLabels &&  (
          this.labelType ? this.vActiveSub === this.labelType : this.vActiveSub))
      );
    },
    filterCount () {
      return this.matchingFilms && this.matchingFilms.length
    },

    itemReason () {
      return {
        itemID: this.filmID,
        itemName: this.filmName,
        itemType: this.rowType
      }
    },
    storyHeader () {
      return {}
    },
    reasons () {

      return this.matchingFilms && this.matchingFilms.map(f => {

        const itemReason = {
          ...f,
          matchType: 'film',
          matchID: f.Film.id,
          match: f.Film.filmName,
          filmID: f.Film.id
        }
        return {
          itemID: this.filmID,
          itemName: this.filmName,
          itemType: "film",
          itemReason,
          isThisFilm: this.isThisFilm(f),
          MatchReasons: [itemReason],
          score: this.refScore(f),
          colorName: this.isThisFilm(f) ? 'accent' : 'secondary'
        }
      });
    },
    matchingFilms() {
      // use the slider to only show those in confidence
      return this.hits && this.hits.filter(f=>this.refScore(f) >= this.confidence)
    },
    thisFilm() {
      const matches = this.hits && this.hits.filter(f=>f.filmID === this.filmID);
      return matches && matches[0]
    },
    referenceScore() {
      return this.thisFilm && this.thisFilm.score
    },
    showLabels() {
      return this.bigActiveSection === "labelsection" || this.alwaysShow;
    },
    tooltips() {
      return settings.tooltips;
    },
    labelColor() {
      return getIconColor("labels");
    },
    viLabelData() {
      return this.ViLabels;
    },
    filmMasterID() {
      return this.fmid;
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },
  apollo: {
    Disambig: {
      skip() {
        return !this.filmMasterID || !this.showCardDetail || !this.count
      },
      query: Disambig,
      fetchPolicy:'cache-and-network',
      variables() {
        return {
          id: this.filmMasterID,
          disambigTypes: this.disambigTypes
        }
      }
    }
  }
};
</script>
